// extracted by mini-css-extract-plugin
module.exports = {"separator":"Separator_separator__3Z9Ss","rotation":"Separator_rotation__DzYlb"};